module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_22-0c3b0fad4c89d5662d9d1945e72a2c17.jpg";